import { render, staticRenderFns } from "./BaseAttributeTemplate.vue?vue&type=template&id=10bfeb81&scoped=true"
import script from "./BaseAttributeTemplate.vue?vue&type=script&lang=js"
export * from "./BaseAttributeTemplate.vue?vue&type=script&lang=js"
import style0 from "./BaseAttributeTemplate.vue?vue&type=style&index=0&id=10bfeb81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bfeb81",
  null
  
)

/* custom blocks */
import block0 from "./BaseAttributeTemplate.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports